import { render } from "./OidcAuth.vue?vue&type=template&id=01481f9f"
import script from "./OidcAuth.vue?vue&type=script&lang=js"
export * from "./OidcAuth.vue?vue&type=script&lang=js"

import "./OidcAuth.vue?vue&type=style&index=0&id=01481f9f&lang=css"

import exportComponent from "D:\\a\\1\\s\\Vind\\VindFront\\VindFrontVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__